import React, { useContext, useEffect } from "react";
// import ceo from  '../../assets/ceo.jpg'
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { FromLeft } from "../../utils/Animation";
import "./ceoMessage.scss";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";

const CeoMessage = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView();

  const lang = useContext(LangContext);
  const nep = lang.state.np;

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["ceoMessageData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/page/detail/ceos-message`)
        .then((res) => res.data),
  });

  if (isFetching || isLoading) return <Loader />;

  if (error) return "An error has occurred: " + error.message;

  // Select data based on language
  const coverImage = nep
    ? data?.detail?.np?.CoverImage
    : data?.detail?.en?.CoverImage;
  const pageTitle = nep
    ? data?.detail?.np?.PageTitle
    : data?.detail?.en?.PageTitle;
  const description = nep
    ? data?.detail?.np?.Description
    : data?.detail?.en?.Description;

  return (
    <div className="ceoMessageSectionMainBgWrapper">
      <div className="ceoMessageSectionMainContainer">
        <motion.img
          ref={ref}
          animate={controls}
          initial="hidden"
          variants={FromLeft}
          src={coverImage}
          alt={nep ? "प्रमुख कार्यकारी अधिकृतको तस्वीर" : "CEO portrait"}
        />

        <div className="ceoMessageSectionTextContainer">
          <h3>{pageTitle}</h3>
          <div
            style={{ textAlign: "justify", hyphens: "auto" }}
            className="ceoMessageCKContent"
            dangerouslySetInnerHTML={{ __html: description }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default CeoMessage;
